export interface LineItemReorderedProps {
  estimate_id: string;
  page_id: string;
  line_item_id: string;
  from_index: number;
  to_index: number;
  item_count: number;
  insert_index: number;
  is_contiguous_selection: boolean;
}

export const LINE_ITEM_EVENTS = {
  REORDERED: "line_item_reordered",
} as const;

export interface LineItemEventPropertiesMap {
  [LINE_ITEM_EVENTS.REORDERED]: LineItemReorderedProps;
}
